var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box_card_wrapper"},[_c('div',{staticClass:"box_wrapper"},[_c('img',{attrs:{"src":_vm.getIcon}}),_c('p',{staticClass:"box_title"},[_vm._v(_vm._s(_vm.title))])]),_c('el-card',{staticClass:"box_card"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }